export { closeBranchesForJoin } from './closeBranchesForJoin'
